import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { AgreementsNamespace, AgreementsReducer } from './store/agreenments/agreements-state';
import { AgreementsEffects } from './store/agreenments/agreements.effects';
import { TellentOrganizationEffects } from './store/tellent-organization.effects';
import {
  TellentOrganizationNamespace,
  TellentOrganizationReducer,
} from './store/tellent-organization.store';

@NgModule({
  imports: [
    StoreModule.forFeature(TellentOrganizationNamespace, TellentOrganizationReducer),
    StoreModule.forFeature(AgreementsNamespace, AgreementsReducer),
    EffectsModule.forFeature([TellentOrganizationEffects, AgreementsEffects]),
  ],
})
export class TellentOrganizationDataModule {}

export const tellentAgreementDataProviders = [
  provideState(AgreementsNamespace, AgreementsReducer),
  provideEffects([AgreementsEffects]),
];
